import React from 'react';
import { Input, Checkbox } from '../../../../common/components/formControls';
import { Field } from 'redux-form';
import validators from '../../../../common/services/validators';

const SaferpayForm = ({ enabled, t }) => {
	return (
		<div>
			<Field name='username' component={Input} required type='text' label={t('Saferpay_Username')} validate={enabled && validators.required} trimOnBlur />
			<Field name='password' component={Input} required type='text' label={t('Saferpay_Password')} validate={enabled && validators.required} trimOnBlur />
			<Field name='customerId' component={Input} required type='text' label={t('Saferpay_CustomerId')} validate={enabled && validators.required} trimOnBlur />
			<Field name='terminalId' component={Input} required type='text' label={t('Saferpay_TerminalId')} validate={enabled && validators.required} trimOnBlur />
			<Field name='additionalFee' component={Input} type='text' label={t('PaymentMethod_AdditionalFee')} validate={[validators.number]} />
			<Field name='isAdditionalFeePercentage' component={Checkbox} label={t('PaymentMethod_IsAdditionalFeePercentage')} help={t('PaymentMethod_AdditionalFeeComplianceNote')} normalize={v => !!v} />
			<Field name='useSandbox' component={Checkbox} label={t('Saferpay_UseSandbox')} help={t('PaymentMethod_UseSandbox_HelpText')} normalize={(v) => !!v} />
		</div>
	);
};


export default SaferpayForm;